var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 28.875H6.125C5.66087 28.875 5.21575 28.6906 4.88756 28.3624C4.55937 28.0342 4.375 27.5891 4.375 27.125V6.125C4.375 5.66087 4.55937 5.21575 4.88756 4.88756C5.21575 4.55937 5.66087 4.375 6.125 4.375H35.875C36.3391 4.375 36.7842 4.55937 37.1124 4.88756C37.4406 5.21575 37.625 5.66087 37.625 6.125V27.125C37.625 27.5891 37.4406 28.0342 37.1124 28.3624C36.7842 28.6906 36.3391 28.875 35.875 28.875H32.375",
    stroke: "#065699",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 23.625L19.25 28.875L16.625 26.25",
    stroke: "#065699",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 8.75V14H14V8.75H8.75Z",
    stroke: "#065699",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 9.625H19.25",
    stroke: "#065699",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 9.625H24.5",
    stroke: "#065699",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28 9.625H29.75",
    stroke: "#065699",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.375 13.125H29.75",
    stroke: "#065699",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 13.125H21.875",
    stroke: "#065699",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21 36.75L26.355 33.5388C27.3909 32.9164 28.248 32.0365 28.8429 30.9846C29.4379 29.9327 29.7504 28.7447 29.75 27.5362V20.125L21 16.625L12.25 20.125V27.5362C12.2496 28.7447 12.5621 29.9327 13.1571 30.9846C13.752 32.0365 14.6091 32.9164 15.645 33.5388L21 36.75Z",
    stroke: "#065699",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDo);
export default __webpack_public_path__ + "static/media/d&o.3f2785419dd795183caa96f65a1120b9.svg";
export { ForwardRef as ReactComponent };